import defaultLogo from "../assets/images/logoDefault.png";
import qrcodeapp from "../assets/images/qrcodeapp.png";

/**
 * Initial Form State
 * @type {object}
 */

export const formData = {
  formActive: 11, // 10
  preview: false,
  loading: true,
  apiError: false,
  activeProgram: 1,
  startForm: false,
  tempForm: {},
  screenLoading: false,
  brand: {
    titleForm: "Brand",
    loading: false,
    isLandscape: false,
    logo: {
      loading: false,
      error: false,
      type: "upload",
      src: defaultLogo,
      blob: "",
      upload: 0,
    },
    footer: {
      src: defaultLogo,
      upload: 0,
      background: "#000000",
    },
    colorBaground: {
      type: "colorPicker",
      code: null,
    },
    gradientBaground: {
      type: "colorPicker",
      code: "#1E1057",
    },
    closeBackground: {
      type: "colorPicker",
      code: "#4100D6",
    },
    closeColor: {
      type: "colorPicker",
      code: "#ffffff",
    },
  },
  welcome: {
    titleForm: "Welcome",
    display: 0,
    loading: false,
    img: {
      loading: false,
      error: false,
      type: "upload",
      title: "Image",
      src: "",
      blob: "",
    },
    button: {
      type: "textEditor",
      title: "Button",
      subtitle: "Button Text",
      subtitle2: "Choose a color for your button",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: "20",
      fontWeight: false,
      fontStyle: false,
      textDecoration: false,
      fontFamily: "Arial",
      value: "GET STARTED",
      borderColor: "#4100D6",
    },
  },
  begin: {
    titleForm: "Begin",
    loading: false,
    video: {
      loading: false,
      error: false,
      type: "upload",
      src: "",
      blob: "",
    },
    button: {
      type: "textEditor",
      title: "Button",
      subtitle: "Button Text",
      subtitle2: "Choose a color for your button",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: "20",
      fontWeight: false,
      fontStyle: false,
      textDecoration: false,
      fontFamily: "Arial",
      value: "Begin",
      borderColor: "#4100D6",
    },
  },
  howScanWork: {
    titleForm: "How does scan works",
    loading: false,
    header: {
      type: "textEditor",
      title: "Title",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "How does scan work?",
      borderColor: "#1E1057",
    },
    checkbox: {
      type: "textEditor",
      title: "Title",
      color: "#ffffff",
      fontSize: 12,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value:
        "I hereby affirm my understanding and acceptance of the stipulated ",
    },
    content: {
      type: "textareaEditor",
      title: "Explanation",
      color: "#ffffff",
      background: "#352760",
      fontSize: 12,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value:
        "Don't worry it's not a picture! Transdermal Optical Imaging (TOI) uses a conventional video camera to measure the blood flow patterns and pulse rates in your face to predict various aspects of your health, securely processed, analyzed and returned to you in the form of a result.",
      borderColor: "#352760",
    },
    image: {
      loading: false,
      error: false,
      type: "upload",
      title: "Image",
      src: "",
      blob: "",
    },
    button: {
      type: "textEditor",
      title: "Button",
      subtitle: "Button Text",
      subtitle2: "Choose a color for your button",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: 16,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Ok, Got it",
      borderColor: "#4100D6",
    },
    contentBottom: {
      type: "textareaEditor",
      title: "Footer",
      color: "#eeeeee",
      background: "#1E1057",
      fontSize: 12,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value:
        'By clicking "I understand," I consent to use of software to measure my facial blood flow patterns and pulse rate to provide an analysis of my current state.',
      borderColor: "#1E1057",
    },
  },
  termsConditions: {
    titleForm: "Terms & Conditions",
    loading: false,
    header: {
      type: "textEditor",
      title: "Header",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Terms & Conditions",
      borderColor: "#1E1057",
    },
    content: {
      type: "textareaEditor",
      title: "Explanation",
      color: "#ffffff",
      background: "#352760",
      fontSize: 12,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value:
        "Please read the Agreement carefully before using the Service. By accessing or using the Service, you agree to be bound by this Agreement and by our Privacy Policy whether or not you are a registered user of our Service. If you do not agree to all the terms and conditions of this Agreement, you shouldn't and aren't permitted to use the Service.",
      borderColor: "#352760",
    },
    image: {
      loading: false,
      error: false,
      type: "upload",
      title: "Image",
      src: "",
      blob: "",
    },
    button: {
      type: "textEditor",
      title: "Button",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: 16,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "I understand",
      borderColor: "#4100D6",
    },
    contentBottom: {
      type: "textareaEditor",
      title: "Footer",
      color: "#eeeeee",
      background: "#1E1057",
      fontSize: 12,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value:
        'By clicking "I understand," I consent to use of software to measure my facial blood flow patterns and pulse rate to provide an analysis of my current state.',
      borderColor: "#1E1057",
    },
  },
  form: {
    titleForm: "Patient Information",
    display: 1,
    loading: false,
    question1: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "What is your current age?",
      borderColor: "#1E1057",
    },
    label10: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "years",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "years",
      borderColor: "#1E1057",
    },
    error10: {
      type: "textEditor",
      title: "Error 10",
      subtitle: "Enter your error message",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Please enter a valid age between 18 and 110",
      borderColor: "#1E1057",
    },
    question2: {
      type: "textEditor",
      title: "Question 2",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "What is your weight?",
      borderColor: "#1E1057",
    },
    error20: {
      type: "textEditor",
      title: "Error 20",
      subtitle: "Enter your error message",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Please enter a valid weight between 30kg and 300kg",
      borderColor: "#1E1057",
    },
    error21: {
      type: "textEditor",
      title: "Error 21",
      subtitle: "Enter your error message",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Please enter a valid weight between 66lb and 661lb",
      borderColor: "#1E1057",
    },
    label20: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "kgs",
      borderColor: "#1E1057",
    },
    label21: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "lbs",
      borderColor: "#1E1057",
    },
    question3: {
      type: "textEditor",
      title: "Question 3",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "What is your height without your shoes on?",
      borderColor: "#1E1057",
    },
    error30: {
      type: "textEditor",
      title: "Error 30",
      subtitle: "Enter your error message",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Please enter a valid height between 110cm and 220cm",
      borderColor: "#1E1057",
    },
    error31: {
      type: "textEditor",
      title: "Error 31",
      subtitle: "Enter your error message",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Please enter a valid height between 1ft and 9ft",
      borderColor: "#1E1057",
    },
    label30: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "cm",
      borderColor: "#1E1057",
    },
    label31: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "ft/in",
      borderColor: "#1E1057",
    },
    question4: {
      type: "textEditor",
      title: "Question 4",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "What is your birth gender?",
      borderColor: "#1E1057",
    },
    question5: {
      type: "textEditor",
      title: "Question 4",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Right now, do you feel well hydrated?",
      borderColor: "#1E1057",
    },
    error40: {
      type: "textEditor",
      title: "Error 40",
      subtitle: "Enter your error message",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Please enter a valid height between 0in and 11in",
      borderColor: "#1E1057",
    },
    label40: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Female",
      borderColor: "#1E1057",
    },
    label41: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Male",
      borderColor: "#1E1057",
    },
    label42: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Yes",
      borderColor: "#1E1057",
    },
    label43: {
      type: "textEditor",
      title: "Question 1",
      subtitle: "Enter your question",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "No",
      borderColor: "#1E1057",
    },
    button: {
      type: "textEditor",
      title: "Button",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: 16,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Next",
      borderColor: "#4100D6",
    },
  },
  results: {
    titleForm: "Results",
    activeForm: 0,
    tabDisplay: 0,
    loading: false,
    header: {
      type: "textEditor",
      title: "Add a header",
      color: "#ffffff",
      background: "#1E1057",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Your scan results",
      borderColor: "#1E1057",
    },
    download: {
      type: "textEditor",
      title: "Button",
      subtitle: "Button Text",
      subtitle2: "Choose a color for your button",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: "20",
      fontWeight: false,
      fontStyle: false,
      textDecoration: false,
      fontFamily: "Arial",
      value: "Download App",
      borderColor: "#4100D6",
    },
    footer: {
      type: "textareaEditor",
      title: "Footer",
      color: "#eeeeee",
      background: "#1E1057",
      fontSize: 12,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value:
        "Notice: These numbers are only estimates and are not a substitute for the judgement of a health care professional. They are intended to improve awareness of general wellness.",
      borderColor: "#1E1057",
    },
    listWidgets: [
      {
        id: 1,
        title: "Heart Rate",
        value: 0,
        code: "HR_BPM",
        label: "",
        background: "#0000001a",
        showIcon: false,
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: true,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Heart Rate",
          borderColor: "#1E1057",
          textAlign: "center",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#240f52",
          fontSize: 16,
          fontWeight: "bold",
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: false,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: `Heart rate (or pulse rate) is the frequency of the heartbeat measured by the number of contractions of the heart per minute (beats per minute, or bpm).\n\nThe heart rate can vary according to the body's physical needs, including the need to absorb oxygen and excrete carbon dioxide, but is also modulated by numerous factors, including (but not limited to) genetics, physical fitness, stress or psychological status, diet, drugs, hormonal status, environment, and disease/illness as well as the interaction between and among these factors.\n\nIt is usually equal or close to the pulse measured at any peripheral point.`,
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 18,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok Got it",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 2,
        title: "Stress Index",
        value: 2.2,
        code: "MSI",
        label: "Result 2",
        type: "graph",
        background: "#0000001a",
        highValue: {
          type: "textEditor",
          title: "Enter Label for stress index 0 - 2.9",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 20,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Your stress index is high",
          borderColor: "#1E1057",
        },
        lowValue: {
          type: "textEditor",
          title: "Enter Label for stress index 3.0 - 5",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 20,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Your stress index is low",
          borderColor: "#1E1057",
        },
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: true,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Stress Index",
          borderColor: "#1E1057",
          textAlign: "center",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#240f52",
          fontSize: 16,
          fontWeight: "bold",
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: false,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value:
            "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",
          borderColor: "#352760",
          isList: true,
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 18,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok Got it",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "Extremely Relaxed",
            explaination:
              "A well below normal stress reading results in a very low Stress Index (SI) that is ideal for maintaining good mental and physical health.\nA Sl reading this low suggests the possibility that at this moment, you have nothing to worry about in your life or are in a state of deep relaxation.\nHowever, you may also not be experiencing enough mental arousal to keep you alert in certain tasks. Minimum stress is useful while engaged with daily activities or chores.\nJust as your resting heart rate can vary constantly it is also normal for stress levels to change constantly. This is because your heart rate variability (HRV) is also changing constantly.\nAs a result, it is not unusual to experience variations in your Stress Index results by as much as 1.0 when you take consecutive measurements.",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "Relaxed",
            explaination:
              "Your below normal stress reading results in a lower Stress Index (SI) that is beneficial for long-term psychological and physical health.\nReceiving Sl readings in this zone are most suitable for the home or leisure environments.\nThe ability to activate this lower level of mental arousal may facilitate concentration in difficult or unfamiliar tasks.\nJust as your resting heart rate can vary constantly it is also normal for stress levels to change constantly. This is because your heart rate variability (HRV) is also changing constantly.\nAs a result, it is not unusual to experience variations in your Stress Index results by as much as 1.0 when you take consecutive measurements.",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "Productive",
            explaination:
              "Currently, your stress reading results in a moderate stress index that is not considered harmful to your psychological and physical health.\nMost people work optimally having a stress index within this stress zone.\nHowever, if your stress remains within this zone under all situations, including moments of relaxation, then you may benefit from learning effective relaxation techniques.\nJust as your resting heart rate can vary constantly it is also normal for stress levels to change constantly. This is because your heart rate variability (HRV) is also changing constantly.\nAs a result, it is not unusual to experience variations in your Stress Index results by as much as 1.0 when you take consecutive measurements.",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "Vigilant",
            explaination:
              "Experiencing higher than normal stress results in a higher Stress Index (SI) that allows you to improve short-term performance by boosting your motivation to do more difficult tasks, particularly those requiring stamina or persistence.\nDuring exposure to this level of stress, you may experience mental or physical strain.\nHowever, Sl readings in this zone should not be a constant part of your life. Otherwise, it may negatively affect your long-term psychological and physical health outcomes.\nJust as your resting heart rate can vary constantly it is also normal for stress levels to change constantly. This is because your heart rate variability (HRV) is also changing constantly.\nAs a result, it is not unusual to experience variations in your Stress Index results by as much as 1.0 when you take consecutive measurements.",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "Overloaded",
            explaination:
              "You are experiencing significantly higher than normal stress indicated by a very high Stress Index (SI) meaning that you will likely encounter impaired performance on certain tasks due to higher than normal anxiety.\nYou may feel unable to calm yourself. Stop what you are doing and take slow, deep breaths. You should also avoid drinking caffeinated beverages like coffee.\nReducing the causes of your stress and engaging in calming activities may help restore your stress balance including practicing deep breathing, yoga, or meditation daily.\nBe aware that prolonged periods of time spent experiencing such elevated SI readings have the potential to cause health complications.\nJust as your resting heart rate can vary constantly it is also normal for stress levels to change constantly. This is because your heart rate variability (HRV) is also changing constantly.\nAs a result, it is not unusual to experience variations in your Stress Index results by as much.",
          },
        ],
      },
      {
        id: 3,
        title: "Biological Age",
        value: 35,
        code: "AGE_SKIN",
        label: "Result 3",
        showIcon: false,
        background: "#0000001a",
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: true,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Biological Age",
          borderColor: "#1E1057",
          textAlign: "center",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#240f52",
          fontSize: 16,
          fontWeight: "bold",
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: false,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: `Believe it or not, researchers and healthcare professionals often consider that we have two different ages: chronological (time-based) and biological (health-based).\n\nChronological age is the number of years a person has been alive, while biological age refers to how a person's body and mind are aging internally.\n\nBiological age takes a number of lifestyle factors into consideration, including diet, exercise, and quality of sleep.\n\nNo matter what your biological age is, it's important to know that you can always make small lifestyle changes into sustainable habits to help you be your best self - whatever that looks and feels like to you!`,
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 18,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok Got it",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 4,
        title: "Hydration Level",
        value: 2.2,
        code: "HYD",
        label: "Result 4",
        background: "#0000001a",
        highValue: {
          type: "textEditor",
          title: "Enter Label for stress index 0 - 2.9",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 20,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Your hydration level is high",
          borderColor: "#1E1057",
        },
        lowValue: {
          type: "textEditor",
          title: "Enter Label for hydration level 3.0 - 5",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 20,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Your hydration level is low",
          borderColor: "#1E1057",
        },
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: true,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Hydration",
          borderColor: "#1E1057",
          textAlign: "center",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#240f52",
          fontSize: 16,
          fontWeight: "bold",
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: false,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value:
            "Hydration level refers to the balance of fluids in the body, with the human body consisting of approximately 60% water. Proper hydration is crucial as water plays a vital role in regulating body temperature, aiding digestion, transporting nutrients and waste, enabling cellular functions, and lubricating joints. Maintaining an adequate hydration level is essential for overall health and well-being, as inadequate hydration can lead to various health issues, including dehydration, which can manifest in symptoms like dry mouth, dark urine, and impaired physical and cognitive performance.",
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 18,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok Got it",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 5,
        title: "Waist-to-height ratio",
        value: 0,
        code: "W2HR",
        label: "",
        showIcon: false,
        background: "#0000001a",
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: true,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Waist-to-height ratio",
          borderColor: "#1E1057",
          textAlign: "center",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#240f52",
          fontSize: 16,
          fontWeight: "bold",
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: false,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: `The waist-to-height ratio is a valuable health indicator that assesses the distribution of body fat by dividing one's waist circumference by their height. This ratio offers a straightforward and practical measure, requiring the measurement of the waist at its narrowest point and the individual's height. A WHtR of 0.5 or lower is generally considered healthy, while values between 0.5 and 0.6 may suggest an increased risk of health issues. A ratio above 0.6 is often associated with a higher risk of cardiovascular diseases and metabolic disorders. This metric is particularly useful as it accounts for body fat distribution, offering a more comprehensive insight into potential health risks than other measures like BMI, which solely considers weight in relation to height. Regular monitoring of the waist-to-height ratio can serve as a simple yet effective tool for individuals and healthcare professionals in assessing and managing overall health.`,
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 18,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok Got it",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 6,
        title: "Body Mass Index\n(BMI)",
        value: 0,
        code: "BMI",
        label: "",
        background: "#0000001a",
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: true,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Body Mass Index\n(BMI)",
          borderColor: "#1E1057",
          textAlign: "center",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#240f52",
          fontSize: 16,
          fontWeight: "bold",
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: false,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: `Body Mass Index (BMI) is a numerical measure calculated by dividing an individual's weight by the square of their height. Widely used as a screening tool to categorize people into different weight status groups, BMI provides a quick assessment of body weight in relation to height. The categories include underweight (BMI less than 18.5), normal weight (BMI 18.5 to 24.9), overweight (BMI 25 to 29.9), and obese (BMI of 30 or greater). While BMI is convenient and easily calculated, it has limitations, such as not distinguishing between muscle and fat. Therefore, it is often considered a starting point for assessing general health, and additional measures may be needed for a more accurate evaluation of an individual's body composition and overall well-being.`,
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 18,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok Got it",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 7,
        title: "Facial Skin Age",
        value: 35,
        code: "FACE_AGE",
        label: "Result 3",
        background: "#0000001a",
        showIcon: false,
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Facial Skin Age",
          borderColor: "#1E1057",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#352760",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value:
            "Facial skin is a complex and dynamic part of the body, serving various functions such as protection, sensation, temperature regulation, and communication. It consists of several layers, including the epidermis, dermis, and subcutaneous tissue. The epidermis is the outermost layer and acts as a barrier against environmental factors, pathogens, and UV radiation. The dermis contains connective tissues, blood vessels, hair follicles, and sweat glands, contributing to the skin's strength and elasticity. The subcutaneous tissue houses fat cells, providing insulation and cushioning.\n\nFactors such as genetics, age, sun exposure, and skincare practices influence the appearance and health of facial skin. Common skincare practices include cleansing, moisturizing, and protecting against sun damage. Additionally, issues like acne, wrinkles, and skin disorders can affect facial skin. Regular skincare routines and a healthy lifestyle contribute to maintaining the vitality and youthful appearance of facial skin. Dermatological interventions, such as cosmetic procedures or medical treatments, are also available for addressing specific concerns and promoting overall skin health.",
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok, Got It",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
    ],
    selectedWidget: [
      {
        id: 1,
        title: "Heart Rate",
        value: 80,
        code: "HR_BPM",
        label: "Result 1",
        background: "#0000001a",
        showIcon: false,
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Heart Rate",
          borderColor: "#1E1057",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#352760",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value:
            "Heart rate (or pulse rate) is the frequency of the heartbeat measured by the number of contractions of the heart per minute (beats per minute, or bpm). ",
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok, Got It",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 2,
        title: "Stress Index",
        value: 2.2,
        code: "MSI",
        label: "Result 2",
        type: "graph",
        background: "#0000001a",
        highValue: {
          type: "textEditor",
          title: "Enter Label for stress index 0 - 2.9",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 20,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Your stress index is high",
          borderColor: "#1E1057",
        },
        lowValue: {
          type: "textEditor",
          title: "Enter Label for stress index 3.0 - 5",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 20,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Your stress index is low",
          borderColor: "#1E1057",
        },
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Heart Rate",
          borderColor: "#1E1057",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#352760",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value:
            "Heart rate (or pulse rate) is the frequency of the heartbeat measured by the number of contractions of the heart per minute (beats per minute, or bpm). ",
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok, Got It",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 3,
        title: "Biological Age",
        value: 35,
        code: "AGE_SKIN",
        label: "Result 3",
        background: "#0000001a",
        showIcon: false,
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Heart Rate",
          borderColor: "#1E1057",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#352760",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value:
            "Heart rate (or pulse rate) is the frequency of the heartbeat measured by the number of contractions of the heart per minute (beats per minute, or bpm). ",
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok, Got It",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 4,
        title: "Hydration Level",
        value: 2.2,
        code: "HYD",
        label: "Result 4",
        background: "#0000001a",
        highValue: {
          type: "textEditor",
          title: "Enter Label for stress index 0 - 2.9",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 20,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Your hydration level is high",
          borderColor: "#1E1057",
        },
        lowValue: {
          type: "textEditor",
          title: "Enter Label for hydration level 3.0 - 5",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 20,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Your hydration level is low",
          borderColor: "#1E1057",
        },
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: true,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Hydration",
          borderColor: "#1E1057",
          textAlign: "center",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#240f52",
          fontSize: 16,
          fontWeight: "bold",
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: false,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value:
            "Hydration level refers to the balance of fluids in the body, with the human body consisting of approximately 60% water. Proper hydration is crucial as water plays a vital role in regulating body temperature, aiding digestion, transporting nutrients and waste, enabling cellular functions, and lubricating joints. Maintaining an adequate hydration level is essential for overall health and well-being, as inadequate hydration can lead to various health issues, including dehydration, which can manifest in symptoms like dry mouth, dark urine, and impaired physical and cognitive performance.",
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 18,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok Got it",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 5,
        title: "Waist-to-height ratio",
        value: 0,
        code: "W2HR",
        label: "",
        background: "#0000001a",
        showIcon: false,
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: true,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Waist-to-height ratio",
          borderColor: "#1E1057",
          textAlign: "center",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#240f52",
          fontSize: 16,
          fontWeight: "bold",
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: false,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: `The waist-to-height ratio is a valuable health indicator that assesses the distribution of body fat by dividing one's waist circumference by their height. This ratio offers a straightforward and practical measure, requiring the measurement of the waist at its narrowest point and the individual's height. A WHtR of 0.5 or lower is generally considered healthy, while values between 0.5 and 0.6 may suggest an increased risk of health issues. A ratio above 0.6 is often associated with a higher risk of cardiovascular diseases and metabolic disorders. This metric is particularly useful as it accounts for body fat distribution, offering a more comprehensive insight into potential health risks than other measures like BMI, which solely considers weight in relation to height. Regular monitoring of the waist-to-height ratio can serve as a simple yet effective tool for individuals and healthcare professionals in assessing and managing overall health.`,
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 18,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok Got it",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 6,
        title: "Body Mass Index\n(BMI)",
        value: 0,
        code: "BMI",
        label: "",
        background: "#0000001a",
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: true,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Body Mass Index\n(BMI)",
          borderColor: "#1E1057",
          textAlign: "center",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#240f52",
          fontSize: 16,
          fontWeight: "bold",
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: false,
          fontStyle: false,
          textDecoration: false,
          fontFamily: "Arial",
          value: `Body Mass Index (BMI) is a numerical measure calculated by dividing an individual's weight by the square of their height. Widely used as a screening tool to categorize people into different weight status groups, BMI provides a quick assessment of body weight in relation to height. The categories include underweight (BMI less than 18.5), normal weight (BMI 18.5 to 24.9), overweight (BMI 25 to 29.9), and obese (BMI of 30 or greater). While BMI is convenient and easily calculated, it has limitations, such as not distinguishing between muscle and fat. Therefore, it is often considered a starting point for assessing general health, and additional measures may be needed for a more accurate evaluation of an individual's body composition and overall well-being.`,
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 18,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok Got it",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
      {
        id: 7,
        title: "Facial Skin Age",
        value: 35,
        code: "FACE_AGE",
        label: "Result 3",
        showIcon: false,
        background: "#0000001a",
        titleWidget: {
          type: "textEditor",
          title: "Header",
          color: "#ffffff",
          background: "#1E1057",
          fontSize: 22,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Facial Skin Age",
          borderColor: "#1E1057",
        },
        button: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#352760",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Explain the result",
          borderColor: "#ffffff",
        },
        explanation: {
          type: "textareaEditor",
          title: "Explanation",
          color: "#ffffff",
          background: "#352760",
          fontSize: 12,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value:
            "Facial skin is a complex and dynamic part of the body, serving various functions such as protection, sensation, temperature regulation, and communication. It consists of several layers, including the epidermis, dermis, and subcutaneous tissue. The epidermis is the outermost layer and acts as a barrier against environmental factors, pathogens, and UV radiation. The dermis contains connective tissues, blood vessels, hair follicles, and sweat glands, contributing to the skin's strength and elasticity. The subcutaneous tissue houses fat cells, providing insulation and cushioning.\n\nFactors such as genetics, age, sun exposure, and skincare practices influence the appearance and health of facial skin. Common skincare practices include cleansing, moisturizing, and protecting against sun damage. Additionally, issues like acne, wrinkles, and skin disorders can affect facial skin. Regular skincare routines and a healthy lifestyle contribute to maintaining the vitality and youthful appearance of facial skin. Dermatological interventions, such as cosmetic procedures or medical treatments, are also available for addressing specific concerns and promoting overall skin health.",
          borderColor: "#352760",
        },
        explanationButton: {
          type: "textEditor",
          title: "Button",
          color: "#ffffff",
          background: "#4100D6",
          fontSize: 16,
          fontWeight: 0,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Ok, Got It",
          borderColor: "#4100D6",
        },
        indexes: [
          {
            backgroundColor: "#AF53DD",
            number: "0 - 1",
            status: 0,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#6E03F0",
            number: "1 - 2",
            status: 1,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#07FFFF",
            number: "2 - 3",
            status: 2,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#14e2d1",
            number: "3 - 4",
            status: 3,
            state: "",
            explaination: "",
          },
          {
            backgroundColor: "#00FFB0",
            number: "4 - 5",
            status: 4,
            state: "",
            explaination: "",
          },
        ],
      },
    ],
    activeMSIIndex: 0,
    showDownloadButton: 0,
    nextButton: {
      type: "textEditor",
      title: "Next",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: 22,
      fontWeight: true,
      fontStyle: false,
      textDecoration: false,
      fontFamily: "Arial",
      value: "Next",
      borderColor: "#4100D6",
      textAlign: "center",
    },
  },
  product: {
    titleForm: "Product recommendations",
    display: 0,
    loading: true,
    criteria: "MSI",
    stressDetails: [
      {
        title: "Stress Index 0-2.9",
        header: {
          type: "textEditor",
          title: "Title",
          color: "#000000",
          fontSize: 14,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Here are your recommendations!!!!",
          textAlign: "center",
        },
        row1: {
          description: {
            type: "textEditor",
            title: "Add your description",
            color: "#000000",
            fontSize: 14,
            fontWeight: false,
            fontStyle: 0,
            textDecoration: 0,
            fontFamily: "Arial",
            value: "Try these snacks for a flavor boost!",
            textAlign: "center",
          },
          images: [
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
          ],
        },
        row2: {
          description: {
            type: "textEditor",
            title: "Add your description",
            color: "#000000",
            fontSize: 14,
            fontWeight: false,
            fontStyle: 0,
            textDecoration: 0,
            fontFamily: "Arial",
            value: "Try one of these snacks with energy to help keep going!",
            textAlign: "center",
          },
          images: [
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
          ],
        },
      },
      {
        title: "Stress Index 3.0-5",
        header: {
          type: "textEditor",
          title: "Title",
          color: "#000000",
          fontSize: 14,
          fontWeight: true,
          fontStyle: 0,
          textDecoration: 0,
          fontFamily: "Arial",
          value: "Here are your recommendations!!!!",
          textAlign: "center",
        },
        row1: {
          description: {
            type: "textEditor",
            title: "Add your description",
            color: "#000000",
            fontSize: 14,
            fontWeight: 0,
            fontStyle: 0,
            textDecoration: 0,
            fontFamily: "Arial",
            value: "Try these snacks for a flavor boost",
            textAlign: "center",
          },
          images: [
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
          ],
        },
        row2: {
          description: {
            type: "textEditor",
            title: "Add your description",
            color: "#000000",
            fontSize: 14,
            fontWeight: 0,
            fontStyle: 0,
            textDecoration: 0,
            fontFamily: "Arial",
            value: "Try one of these snacks with energy to help keep going",
            textAlign: "center",
          },
          images: [
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
            {
              loading: false,
              error: false,
              type: "upload",
              src: "",
              blob: "",
              link: "",
              upload: 0,
            },
          ],
        },
      },
    ],
    help: {
      type: "textEditor",
      title: "Decision Point",
      color: "#000000",
      fontSize: 14,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Did this help you make your decision?",
      textAlign: "center",
    },
    primaryButton: {
      type: "textEditor",
      title: "Button",
      color: "#ffffff",
      fontSize: 14,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Great suggestion!",
      background: "#3f0fcc",
      borderColor: "#4c1bde",
      textAlign: "center",
    },
    secondaryButton: {
      type: "textEditor",
      title: "Button",
      color: "#ffffff",
      fontSize: 14,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Not today",
      background: "#400ed8",
      borderColor: "#4a14eb",
      textAlign: "center",
    },
    explanation: {
      type: "textEditor",
      title: "Explanation",
      color: "#000000",
      fontSize: 14,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "This experience is intended for experimental purposes only.",
      textAlign: "center",
    },
    activeTab: "0",
  },
  end: {
    titleForm: "End",
    loading: false,
    downloadable: false,
    image: {
      loading: false,
      error: false,
      type: "upload",
      title: "Image",
      src: qrcodeapp,
      blob: "",
    },
    header: {
      type: "textareaEditor",
      title: "Text",
      color: "#ffffff",
      background: "#352760",
      fontSize: 32,
      fontWeight: "bold",
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Thank you for visiting",
      borderColor: "#352760",
    },
    content: {
      type: "textareaEditor",
      title: "Text",
      color: "#ffffff",
      background: "#352760",
      fontSize: 20,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value:
        "Take back control of your biological age with our simple, personalized plans.",
      borderColor: "#352760",
    },
    button: {
      type: "textEditor",
      title: "Next user",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Next user",
      borderColor: "#4100D6",
    },
    webButton: {
      type: "textEditor",
      title: "",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: 22,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "",
      borderColor: "#4100D6",
    },
    webButtonURL: "",
  },
  options: {
    titleForm: "Settings",
    loading: false,
    header: {
      type: "textEditor",
      title: "TimeOut",
      color: "#ffffff",
      background: "#4100D6",
      fontSize: 20,
      fontWeight: 0,
      fontStyle: 0,
      textDecoration: 0,
      fontFamily: "Arial",
      value: "Option 1",
      borderColor: "#4100D6",
    },
  },
};
